import React from 'react';
import { Create, required, TextInput } from 'react-admin';
import { FormSpy } from 'react-final-form';
import { Grid, FormLabel, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import SimpleFormWithSave from '../../../core/components/form/SimpleFormWithSave';
import DateInput from '../../../core/components/forked/input/DateInput';
import { isValidDate } from '../../../core/utils';
import TimeInput from '../../../core/components/inputs/TimeInput';
import RichTextInput from '../../../core/components/inputs/RichTextInput';
import moment from 'moment';

const styles = () => ({
  fullWidth: {
    width: '100%'
  }
});

const UserActivityFormFields = props => {
  const { operation, record } = props;
  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <DateInput
            source="dateTime"
            label="Date"
            variant="standard"
            validate={[isValidDate, required()]}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <TimeInput
            source="time"
            variant="standard"
            label="Time"
            validate={[required()]}
          />
        </Grid>
        {operation !== 'Create' && (
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormLabel>Created By</FormLabel>
              </Grid>
              <Grid item xs={12}>
                <Typography>{record.createdOrUpdatedBy}</Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <TextInput
            source="subject"
            label="Subject"
            options={{ autoComplete: 'off' }}
            variant="standard"
            validate={[required()]}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <RichTextInput
            source="details"
            label="Details"
            displayingVariables={false}
            validate={[required()]}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const UserActivityForm = props => {
  const {
    handleSubmit,
    setActivityForm,
    activityForm,
    setActivityFormValues,
    activityFormValues,
    operation,
    classes,
    open,
    record,
    handleClose,
    userId,
    ...operationProps
  } = props;
  let editRecord;
  if (operation === 'Edit') {
    editRecord = {
      ...pick(record, ['subject', 'details', 'dateTime', 'activityId', 'time'])
    };
    if (!editRecord.time) {
      const dateTime = record.dateTime;
      const hours = moment(dateTime).get('hour');
      const minutes = moment(dateTime).get('minute');
      editRecord.time =
        ('00' + hours.toString()).slice(-2) +
        ':' +
        ('00' + minutes.toString()).slice(-2);
    }
  }
  return (
    <Create
      {...operationProps}
      record={editRecord}
      className={classes.fullWidth}
    >
      <SimpleFormWithSave
        toolbar={null}
        resource="activities"
        onSave={handleSubmit}
        variant="standard"
        margin="normal"
      >
        <React.Fragment>
          <UserActivityFormFields operation={operation} record={record} />
          <FormSpy>
            {({ form, values }) => {
              if (!isEqual(activityFormValues, values)) {
                setActivityFormValues(values);
              }
              if (!activityForm && open) {
                setActivityForm(form);
              }
              return null;
            }}
          </FormSpy>
        </React.Fragment>
      </SimpleFormWithSave>
    </Create>
  );
};

export default withStyles(styles)(UserActivityForm);
